import { render, staticRenderFns } from "./DialogComments.vue?vue&type=template&id=0c53a639&scoped=true"
import script from "./DialogComments.vue?vue&type=script&lang=js"
export * from "./DialogComments.vue?vue&type=script&lang=js"
import style0 from "./DialogComments.vue?vue&type=style&index=0&id=0c53a639&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53a639",
  null
  
)

export default component.exports